<template>
  <div>
    <section id="list-product-lending" class="container">
      <h1 class="product-header">Pembiayaan Kepemilikan Motor Baru</h1>
      <p class="product-description">
        Punya Motor Idaman Dengan Cara Halal, Gampang! <br />
        Mau Angsuran Ringan? atau Uang Muka Bersahabat? Anda tinggal tentukan
        pilihan!
      </p>

      <div class="product-list">
        <!-- Header Palsu -->
        <div class="row table-header mb-2 d-none d-md-flex">
          <div class="table-header-text col-md-3 font-weight-bold">
            Jenis Motor
          </div>
          <div class="table-header-text col-md-2 font-weight-bold">
            Angsuran
          </div>
          <div class="table-header-text col-md-2 font-weight-bold">
            Uang Muka
          </div>
          <div class="table-header-text col-md-2 font-weight-bold">Harga</div>
          <div
            class="table-header-text col-md-3 border-left-custom h-100"
          >
            Urutkan Harga
          </div>
        </div>

        <h2
          class="d-flex d-md-none mt-5"
          style="
            font-size: 24px;
            letter-spacing: 0;
            text-transform: capitalize;
            font-weight: 600;
          "
        >
          List Produk
        </h2>
        <div v-if="loading" class="product-card mb-4 p-3 skeleton" v-for="index in 5" :key="index">
          <div class="row align-items-center p-4">
            <div class="col-md-3 mb-2 mr-2 mb-md-0 text-center text-md-left skeleton-img"></div>
            <div class="col-md-3 skeleton-text"></div>
            <div class="col-md-3 skeleton-text"></div>
          </div>
        </div>

        <!-- Isi Konten -->
        <div class="product-card mb-4 p-3" v-for="(product, index) in itemLendings" :key="index">
          <router-link
            :to="{ name: 'detail_produk_lending' }"
            class="product-card-link"
            
          >
          <div 
            @click="saveProductId(product.id)" 
            >
            <div class="d-flex justify-content-between align-items-center mb-2 px-2">
              <!-- Nama Sub Brand -->
              <div class="table-header-text font-weight-bold" style="font-size: 18px;">
                {{ product.sub_brand.name }}
              </div>
  
              <!-- Logo dan Nama Perusahaan -->
              <div class="d-flex align-items-center">
                <div class="table-header-text font-weight-bold mr-3" style="font-size: 16px;">
                  {{ product.mitra.mitra_profile.nama_organisasi_perusahaan }}
                </div>
                <!-- Icon Love -->
                <i class="fas fa-heart text-secondary" style="font-size: 18px; margin-right: 8px; cursor: pointer;"></i>
  
                <!-- Icon Share -->
                <i class="fas fa-share-alt text-secondary" style="font-size: 18px; cursor: pointer;"></i>
                  </div>
            </div>
  
            <div class="row align-items-center">
              <!-- Gambar -->
              <div class="col-md-3 mb-2 mb-md-0 text-center text-md-left">
                <img
                  :src="getRandomImage(product.sub_brand.images)"
                  alt="product-image"
                  class="img-fluid mb-2 product-image"
                />
              </div>
  
              <!-- Angsuran -->
              <div class="col-md-2 mb-2 mb-md-0 text-center text-md-left">
                <p class="table-header-text font-weight-bold mb-0" style="font-size: 20px;">{{ formatRupiah(product.min_installment) }}</p>
              </div>
              
              <!-- Uang Muka -->
              <div class="col-md-2 mb-2 mb-md-0 text-center text-md-left">
                <p class="table-header-text font-weight-normal mb-0" style="font-size: 20px;">{{ formatRupiah(product.down_payment) }}</p>
              </div>
              
              <!-- Harga -->
              <div class="col-md-2 mb-2 mb-md-0 text-center text-md-left">
                <p class="table-header-text font-weight-normal mb-0" style="font-size: 20px;">{{ formatRupiah(product.price) }}</p>
              </div>
              <div class="col-md-2 mb-2 mb-md-0 text-center text-md-left">
                <b-button block type="submit" variant="custom" class="border-0 custom-button">
                  Ajukan Sekarang
                </b-button>
              </div>
  
              <!-- Urutkan Harga -->
              <div class="col-md-3 text-center text-md-left">
                <!-- Tombol aksi / sort -->
              </div>
            </div>
          </div>
        </router-link>
        </div>
      </div>
    </section>

    <NewFooterClient />
  </div>
</template>

<script>
// Assets
import FilterIcon1 from "@/assets//images/landing_page/ic-filter.png";
import FilterIcon2 from "@/assets//images/landing_page/ic-filter-2.png";

// Components
import NewFooterClient from "@/components/landing-page/newFooterClient.vue";

// Data
import { efundingLendingProducts } from "@/utils/efunding_lending_products";
import Cookies from 'js-cookie';
import ProductLending from "../api/produkLendingV3";

export default {
  components: { NewFooterClient },
  data() {
    return {
      efundingLendingProducts,
      FilterIcon1,
      FilterIcon2,
      itemLendings: [],
      loading: true,
      sub_brand_id: null,
    };
  },
  mounted(){
    this.loadData();
  },
  watch: {
    '$route.params.sub_brand_id': {
      handler(newVal) {
        this.sub_brand_id = newVal;
        this.loadData();
      },
      immediate: true,
    }
  },
  methods: {
    saveProductId(productId) {
      Cookies.set('product_id', productId);
    },
    loadData(){
      this.loading = true; 
      this.sub_brand_id = Cookies.get('sub_brand_id');
      if (!this.sub_brand_id) {
        this.$nextTick(() => {
          this.$router.push({ name: 'list_lending_detail' });
        });
        return;
      }
      try{
        const params = {
          search_sub_brand_id : this.sub_brand_id,
          with: 'subBrand.images,brand,mitra.mitra_profile' 
        };
        ProductLending.index(params)
        .then(res => {
          this.itemLendings = res.data.data;
          this.loading = false;
        })
        .catch(err => {
          console.error("error produk klending : ", err);
          this.loading = false; // Set loading ke false jika error
        })
      }catch (error) {
          console.error('Error loading lending product :', error);
          this.loading = false;
      }
    },
    getRandomImage(images) {
      if (!images || images.length === 0) return ''; // fallback
      const randomIndex = Math.floor(Math.random() * images.length);
      return this.getImageUrl(images[randomIndex].image);
    },
    getImageUrl(url){
      return `${process.env.API_URL}${url}`;
    },
    formatRupiah(value) {
      // Menghilangkan angka di belakang koma
      const cleanValue = Math.floor(parseFloat(value)); 

      if (!cleanValue) return "Rp. 0";
      const numberString = cleanValue
          .toString()
          .replace(/[^,\d]/g, "")
          .toString();
      let rest = numberString.length % 3;
      let rupiah = numberString.substr(0, rest);
      const thousand = numberString.substr(rest).match(/\d{3}/gi);

      if (thousand) {
          const separator = rest ? "." : "";
          rupiah += separator + thousand.join(".");
      }

      return "Rp. " + rupiah;
  },
  }
};
</script>

<style>
.container {
  max-width: 90%;
}
.text-table-orange {
  color: #f7bd3a;
  margin-bottom: 0;
  font-weight: 600;
}
.product-card {
  border: 1px solid #eee;
  border-radius: 12px;
  background-color: #fff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  border: 1px solid #b3b3b3;
}

.table-header {
  padding: 12px;
  background-color: #fff;
  border-radius: 8px;
  border: 1px solid #b3b3b3;
}
.product-image {
  width: 240px;
  height: auto;
}
.table-header-text {
  color: #13346c;
}
.border-left-custom {
  border-left: 1px solid rgba(0, 0, 0, 0.5);
  padding-top: 0;
  padding-bottom: 0;
}
.product-header {
  font-size: 48px;
  font-weight: 800;
  text-transform: capitalize;
  text-align: center;
}
.product-description {
  color: #13346c;
  font-size: 20px;
  text-align: center;
  font-weight: 600;
}
.filter-product {
  margin: 48px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 80px;
}
.filter-card {
  height: 100%;
  background-color: #f9f9f9;
  border: 1px solid #b3b3b3;
  padding: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 16px;
  gap: 20px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}
.filter-icon {
  width: 100px;
  height: auto;
  margin: auto;
}

@media (max-width: 768px) {
  .product-header {
    font-size: 24px;
    font-weight: 800;
    text-transform: capitalize;
    text-align: center;
  }
  .product-description {
    color: #13346c;
    font-size: 16px;
    text-align: center;
    font-weight: 600;
  }
  .filter-product {
    margin: 48px 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 16px;
  }
  .filter-card {
    height: 100%;
    background-color: #f9f9f9;
    border: 1px solid #b3b3b3;
    padding: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 16px;
    gap: 20px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    width: 100%;
  }
  .filter-icon {
    width: auto;
    height: 100px;
    margin: auto;
  }
}
</style>
<style scoped>
/* Skeleton Loader */
.skeleton {
  background-color: #ffffff;
  border-radius: 8px;
  padding: 16px;
  position: relative;
  overflow: hidden;
  animation: loading-skeleton 1.5s infinite ease-in-out, flicker 1s infinite alternate;
}

/* Efek shimmer (gerakan shimmer) */
@keyframes loading-skeleton {
  0% {
    background-position: -200px 0;
  }
  100% {
    background-position: 200px 0;
  }
}

/* Efek kedap-kedip (flicker) */
@keyframes flicker {
  0% {
    opacity: 0.4;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0.4;
  }
}

.skeleton-img {
  width: 100%;
  height: 120px;
  background: #ececec;
  border-radius: 8px;
  animation: shimmer 1.5s infinite linear;
}

.skeleton-text {
  height: 60px;
  background: #ececec;
  margin-bottom: 10px;
  border-radius: 4px;
  width: 80%;
  animation: shimmer 1.5s infinite linear;
}

.skeleton-text:last-child {
  width: 60%;
}

/* Shimmer effect on the skeleton */
@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}
</style>


// WEBPACK FOOTER //
// src/public/list-lending-detail.vue